// Kept in this browser, not on the user's server-side preferences: whether the assistant hears itself depends on the
// speakers of the computer in use (a headset at the desk, the room's loudspeakers in a meeting), not on the person.
const MUTE_WHILE_SPEAKING_KEY = 'aia.voice.muteMicWhileSpeaking';

// For as long as the page lives, when storage refuses the write (a host iframe with third-party storage off, a full
// quota). Ahead of what storage reads: it may still read the value from before the write it refused.
let unstored: boolean | undefined;

/** Whether the microphone is silenced while the assistant's answer plays (Settings, voice conversation). */
export const readMuteMicWhileSpeaking = (): boolean => {
    if (unstored !== undefined) {
        return unstored;
    }
    try {
        return localStorage.getItem(MUTE_WHILE_SPEAKING_KEY) === 'true';
    } catch {
        return false;
    }
};

export const writeMuteMicWhileSpeaking = (on: boolean): void => {
    try {
        if (on) {
            localStorage.setItem(MUTE_WHILE_SPEAKING_KEY, 'true');
        } else {
            localStorage.removeItem(MUTE_WHILE_SPEAKING_KEY);
        }
        unstored = undefined;
    } catch {
        unstored = on;
    }
};

/**
 * Calls back when the Settings page in another tab or window of this browser changes the setting, which reaches no
 * component here through a remount. Returns the unsubscribe.
 */
export const onMuteMicWhileSpeakingChanged = (listener: (on: boolean) => void): (() => void) => {
    const onStorage = (event: StorageEvent) => {
        // A null key is the whole storage cleared.
        if (event.key === MUTE_WHILE_SPEAKING_KEY || event.key === null) {
            listener(readMuteMicWhileSpeaking());
        }
    };
    window.addEventListener('storage', onStorage);
    return () => {
        window.removeEventListener('storage', onStorage);
    };
};
